import { Components, Theme } from '@mui/material'

export const BreadcrumbsOverrides = (
  theme: Theme
): Components['MuiBreadcrumbs'] => ({
  defaultProps: {},
  styleOverrides: {
    root: {
      '&.MuiBreadcrumbs-themeLight': {
        backgroundColor: theme.palette.background.light,
      },
      '&.MuiBreadcrumbs-themeMedium': {
        backgroundColor: theme.palette.background.medium,
        color: theme.palette.grey[400],
        li: {
          '&:last-of-type': {
            color: theme.palette.text.inverted,
          },
          '.MuiLink-root:hover': {
            color: theme.palette.text.inverted,
          },
        },
      },
      '&.MuiBreadcrumbs-themeDark': {
        backgroundColor: theme.palette.background.dark,
        color: theme.palette.text.secondary,
        li: {
          '&:last-of-type': {
            color: theme.palette.text.inverted,
          },
          '.MuiLink-root:hover': {
            color: theme.palette.text.inverted,
          },
        },
      },
    },
    li: {
      '.MuiLink-root:hover': {
        color: theme.palette.text.primary,
      },
    },

    separator: {
      margin: 0,
    },
  },
})
